import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { HomePage } from "../home/home";

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})

export class LoginPage {
  constructor(public navCtrl: NavController, public navParams: NavParams) {

  }

  doLogin() {
    this.navCtrl.push(HomePage);
    console.log("doLogin()");
  };
}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts